export const MODIFY_SHEET_READ = 'MODIFY_SHEET_READ';

export function modifySheetRead(sheetRead){
    return{
        type: MODIFY_SHEET_READ,
        mainState: {
            sheetRead: sheetRead
        }
    }
}